import { docxToPreviewText } from "../text/utils";

export const MAX_FILE_BYTES = 10 * 1024 * 1024;
export const FILE_ACCEPT = ".txt,.md,.docx,.pdf";

/** Plain text out of a .txt/.md/.docx/.pdf, in the browser. Throws an Error whose message is fit to show the person. */
export async function readTextFile(file: File): Promise<string> {
  const name = file.name.toLowerCase();
  if (file.size > MAX_FILE_BYTES) throw new Error(`${file.name} is larger than 10 MB. Paste the part you want to compare instead.`);
  if (name.endsWith(".txt") || name.endsWith(".md")) return await file.text();
  if (name.endsWith(".docx")) {
    try { return await docxToPreviewText(file); }
    catch { throw new Error(`${file.name} isn't a valid .docx file. Open it in Word or Google Docs and save it as .docx, or paste the text.`); }
  }
  if (name.endsWith(".pdf")) {
    let pages: string[][];
    try {
      const { extractPdfTextLines } = await import("../pdf/utils");
      pages = await extractPdfTextLines(file);
    } catch { throw new Error(`${file.name} couldn't be read as a PDF. If it is protected or damaged, paste the text instead.`); }
    const text = pages.map((p) => p.join("\n")).join("\n\n").trim();
    if (!text) throw new Error(`${file.name} has no selectable text (it looks like a scan), so there is nothing to compare. Run it through the OCR tool first, or paste the text.`);
    return text;
  }
  throw new Error(`${file.name} isn't a .txt, .docx or .pdf file. Save it as one of those, or paste the text.`);
}
